exports.components = {
  "component---src-components-projects-details-index-tsx": () => import("./../../../src/components/ProjectsDetails/index.tsx" /* webpackChunkName: "component---src-components-projects-details-index-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

